import { render, staticRenderFns } from "./CRSHome.vue?vue&type=template&id=010f0e65&"
import script from "./CRSHome.vue?vue&type=script&lang=js&"
export * from "./CRSHome.vue?vue&type=script&lang=js&"
import style0 from "./CRSHome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports